import { useMutation, useQueryClient } from '@tanstack/react-query';

import resolvePresetBySlug from '@/requests/library/resolvePresetBySlug';
import { setAppStore } from '@/store';
import buildInputsFromPreset from '@/utils/preset/buildInputsFromPreset';
import { Screen } from '@/types';

const useLibraryItemInfoMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (slug: string) => {
      const preset = await resolvePresetBySlug(slug, queryClient);

      const inputs = buildInputsFromPreset(preset);
      setAppStore({
        selectedPreset: { ...preset, slug },
        inputs,
        screen: Screen.Create,
        isPresetLoading: false,
      });

      return { preset, slug };
    },

    onMutate: () => {
      setAppStore({
        isPresetLoading: true,
        screen: Screen.Create,
      });
    },

    onError: () => {
      setAppStore({
        isPresetLoading: false,
        screen: Screen.Library,
      });
    },
  });
};

export default useLibraryItemInfoMutation;
